import { AbstractControl, ValidatorFn } from '@angular/forms';

export function dateRangeValidator(data_inceput: string, data_finalizare: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
        const dataInceput = control.get(data_inceput);
        const dataFinalizare = control.get(data_finalizare);

        if (dataInceput && dataFinalizare && (dataInceput.touched || dataFinalizare.touched)) {
            const startDate = new Date(dataInceput.value);
            const endDate = new Date(dataFinalizare.value);

            if (endDate < startDate) {
                return { dateRange: true };
            } else {
                return null;
            }
        }
        return null;
    };
}